import { render, staticRenderFns } from "./FlowContacts.vue?vue&type=template&id=03232352&"
import script from "./FlowContacts.vue?vue&type=script&lang=js&"
export * from "./FlowContacts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports